import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Play = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 11 13.19'
  >
    <g>
      <path
        d='M.55.05,10.83,6.29a.36.36,0,0,1,0,.62L.55,13.14A.36.36,0,0,1,0,12.83V.36A.37.37,0,0,1,.55.05Z'
        fill={ color }
        stroke={ color }
      />
    </g>
  </svg>
);

Play.propTypes = { ...iconPropTypes };

Play.defaultProps = { ...iconDefaultProps };

export default Play;